import { httpService } from "./httpService";

export const userMetaService = {
  update(userId: number, formData: FormData) {
    formData.append("_method", "PUT");
    return httpService.postFormDataRequest(`users/${userId}/meta`, formData);
  },
};